module.exports = __webpack_public_path__ + "img/your-ideal-partner.f3731433.svg";